
  import {Component, Vue, Watch} from "vue-property-decorator";
  import VoucherService from "../../services/voucher.service";
  import AuthService from "../../services/auth.service";
  import ApproveDialog from "./dialogs/ApproveDialog.vue";
  import LoadingOverlay from "../core/LoadingOverlay.vue";
  import {Voucher} from "../../models/voucherI";
  import UserDataService from "../../../src/services/userdata.service";
  import {Mutation} from "vuex-class";
  import VoucherDialog from "./dialogs/VoucherDialog.vue";
  import VoucherArchiveDialog from "./dialogs/VoucherArchiveDialog.vue";
  import VoucherParkDialog from "./dialogs/VoucherParkDialog.vue";
  import VoucherUnparkDialog from "./dialogs/VoucherUnparkDialog.vue";

  @Component({
    components: {VoucherDialog, VoucherArchiveDialog, ApproveDialog, LoadingOverlay, VoucherParkDialog, VoucherUnparkDialog}
  })
  export default class OpenVouchers extends Vue {
    @Mutation('SET_HAS_OPEN_SKONTO_VOUCHERS', {namespace: 'userdata'})
    SET_HAS_OPEN_SKONTO_VOUCHERS!: (hasOpenSkontoVouchers: boolean) => void;

    search = "";
    private selectedVoucher: Voucher[] = [];

    private vouchersTableData: Voucher[] = [];
    private parkedVouchersTableData: Voucher[] = [];
    private vouchersLoaded: Voucher[] = [];

    private selectedVoucherForDetails: any = null;
    private mohtamimMaalUser = false;
    private mohtamimMuhasibUser = false;

    private multipleApproval = false;
    private voucherApproveDialogVisible = false;

    private showOverlay = false;

    private vouchersTableHeaders: any[] = [];

    private voucherStatusFilter = "";

    private gesamtBetragSelectedVoucher: number = 0;

    private tab = null;

    private voucherDetailsDialogVisible: boolean = false;

    private voucherArchiveDialogVisible: boolean = false;

    private voucherParkDialogVisible: boolean = false;

    private voucherUnparkDialogVisible: boolean = false;

    beforeCreate() {
        const userRoles = AuthService.getRoles();
        this.mohtamimMuhasibUser = userRoles.indexOf("ROLE_MOHTAMIM_MUHASIB") >= 0;
        this.mohtamimMaalUser    = userRoles.indexOf("ROLE_MOHTAMIM_MAAL") >= 0;
      }

    created() {
      this.loadOpenVouchers();

      let username = AuthService.getUserName();
      let userRoles = AuthService.getRoles();

      if (userRoles.indexOf("ROLE_MOHTAMIM_MUHASIB") >= 0) {
        this.mohtamimMuhasibUser = true;
      }

      if (userRoles.indexOf("ROLE_MOHTAMIM_MAAL") >= 0) {
        this.mohtamimMaalUser = true;
      }

      this.vouchersTableHeaders.push(
        {text: 'Voucher-Nr', value: 'id', filterable: false},
        {text: 'Status', value: 'status', filterable: false},
      );

      if (this.mohtamimMuhasibUser) {
        this.vouchersTableHeaders.push(
          {text: 'Shoba', value: 'department', filterable: false},
        );
      }

      this.vouchersTableHeaders.push(
        {text: 'Vendor-Name', value: 'vendorName', filterable: false},
        {text: 'Betrag', value: 'gesamtBetrag', filterable: false},
        {text: 'Art', value: 'type', filterable: false},
        {text: 'Details', value: 'details', sortable: false, filterable: false, align: 'center'},
      );
    }

    loadOpenVouchers() {
      this.voucherStatusFilter = "Alle";
      this.showOverlay = true;
      this.vouchersLoaded = [];
      this.selectedVoucher = [];
      VoucherService.getOpenVouchers()
        .then((response: any) => {
          response.data.forEach((voucher: Voucher) => {
              // We have to do this filtering, because otherwise, we get doubles, because
              // loadOpenVouchers has been called double times after approving voucher
              // So we check now whether the voucher already is in tabledata
              if (this.vouchersLoaded.filter(v => v.id == voucher.id).length <= 0) {
                this.vouchersLoaded.push(
                  Object.assign(new Voucher(), voucher)
                );
              }
            }
          );
          this.vouchersTableData = [...this.vouchersLoaded.filter(v => v.status != "PARKED")];
          this.parkedVouchersTableData = [...this.vouchersLoaded.filter(v => v.status == "PARKED")];

          this.showOverlay = false;
        })
        .catch((error: any) => {
          this.$notify({
            group: 'foo',
            title: 'Fehler',
            text: error,
            type: 'error'
          });
          this.showOverlay = false;
        })
        .finally(() => {
          setTimeout(() => {
            this.showOverlay = false;
          }, 5000);
        });
    }

    archiveVoucher() {
      if (this.selectedVoucher.length == 0) {
        this.$notify({
          group: 'foo',
          title: 'Fehler',
          text: 'Bitte wählen Sie mindestens ein Voucher aus!',
          type: 'error'
        });
      } else {
        this.voucherArchiveDialogVisible = true;
      }
    }

    parkVoucher() {
      if (this.selectedVoucher.length == 0) {
        this.$notify({
          group: 'foo',
          title: 'Fehler',
          text: 'Bitte wählen Sie mindestens ein Voucher aus!',
          type: 'error'
        });
      } else {
        this.voucherParkDialogVisible = true;
      }
    }

    unparkVoucher() {
      if (this.selectedVoucher.length == 0) {
        this.$notify({
          group: 'foo',
          title: 'Fehler',
          text: 'Bitte wählen Sie mindestens ein Voucher aus!',
          type: 'error'
        });
      } else {
        this.voucherUnparkDialogVisible = true;
      }
    }

    handleCloseArchiveDialog() {
      this.loadOpenVouchers();
      this.voucherArchiveDialogVisible = false;
    }

    handleCloseParkDialog() {
      this.loadOpenVouchers();
      this.voucherParkDialogVisible = false;
    }

    handleCloseUnparkDialog() {
      this.loadOpenVouchers();
      this.voucherUnparkDialogVisible = false;
    }

    handleCloseVoucherApproveDialog() {
      this.voucherApproveDialogVisible = false;
      this.multipleApproval = false;
      this.loadOpenVouchers();
    }

    base64ToArrayBuffer(_base64Str: any) {
      var binaryString = window.atob(_base64Str);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    }

    handleDetails(selectedVoucher: any) {
      this.selectedVoucherForDetails = Object.assign({}, selectedVoucher);
      this.voucherDetailsDialogVisible = true;
    }

    handleCloseDetailsDialog() {
      this.voucherDetailsDialogVisible = false;
      this.loadOpenVouchers();
    }

    excelExport() {
      let ids = this.selectedVoucher.map((item: any) => item.id);
      VoucherService.excelExport(String(ids)).then((response) => {
      var file = new Blob([response.data], {type: 'application/vnd.ms-excel'});
      var url = URL.createObjectURL(file);
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.setAttribute('target', 'blank');
      a.href = url;
      a.download = "vouchers.xlsx";
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    })
    .catch((err) => {
      throw err;
    });
    }
  }
